import {GetPollResponsePayload} from '../../../models/api';
import {PollType} from '../../../models/poll';

export default {
  id: 5,
  name: 'Как часто вы пользуетесь ЕСК',
  type: PollType.Voting,
  descriptionWelcome:
    'Вы недавно совершили покупку в магазине «Пятерочка». Ответьте, пожалуйста, на несколько вопросов по своим впечатлениям',
  descriptionFinish: 'Благодарим за участие! Ваше мнение очень важно для нас',
  isPassed: false,
  statusId: 2,
  statusName: 'Активный',
  questions: [
    {
      id: 4,
      text: 'Как часто вы не пользуетесь ЕСК?',
      typeId: 1,
      typeName: '1 вариант',
      answers: [
        {
          id: 22,
          text: 'Каждый день',
          numberResponses: 20,
        },
        {
          id: 27,
          text: 'Через день',
          numberResponses: 500,
        },
        {
          id: 24,
          text: 'Не каждый день',
          numberResponses: 100,
        },
      ],
    },
  ],
} as GetPollResponsePayload;
